import React from "react";
import {useTranslation} from "react-i18next";
import globant from "assets/images/logos/globant.png";
import {PartnerLink, PartnersLinks, PartnersLinksWrapper, Title} from "./common";

const LINKS = [
	{
		name: "Globant",
		logo: globant,
		href: "https://www.globant.com/",
	},
];

export const RegionalPartnersLinks: React.FC = () => {
	const {t} = useTranslation();

	return (
		<PartnersLinksWrapper>
			<Title>{t("footer.fifa.regional_partners")}</Title>
			<PartnersLinks>
				{LINKS.map((link) => (
					<PartnerLink key={link.name} href={link.href}>
						<img src={link.logo} alt={link.name} />
					</PartnerLink>
				))}
			</PartnersLinks>
		</PartnersLinksWrapper>
	);
};
